import { render, staticRenderFns } from "./BumpersList.vue?vue&type=template&id=05d8f030"
import script from "./BumpersList.vue?vue&type=script&lang=js"
export * from "./BumpersList.vue?vue&type=script&lang=js"
import style0 from "./BumpersList.vue?vue&type=style&index=0&id=05d8f030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports